import { CardContent, CardContentProps, SxProps, Theme } from '@mui/material';

import { appCardContentSx } from './app-card-styles';

/**
 * Main body of the card (title, description, metadata). Grows to fill vertical space.
 */
export function AppCardContent({ sx, ...props }: CardContentProps) {
  return (
    <CardContent
      {...props}
      sx={
        [
          appCardContentSx,
          ...(sx !== undefined ? (Array.isArray(sx) ? sx : [sx]) : []),
        ] as SxProps<Theme>
      }
    />
  );
}
